import React from 'react';
import { styled } from '@linaria/react';
import { useAvivaSelector } from '@redux/hook';
import { get } from 'lodash';
import cimbLogo from '@assets/images/cimb-logo.svg';
import { css } from '@linaria/core';
import { themeDefault } from 'src/theme-revamp';
import Text from '@components/Text';
import { CIMB_Code } from '@static/campaign-code';

const LogoImage = styled.img <LogoComponentProps>`
  width:${props=>props.width || "189px"} ;
  @media screen and (min-width: 768px) {
    width:${props=>props.width || "189px"} ;
  }
  cursor: ${props => props.isClickable ? 'pointer' : 'default'};
`;

const LogoContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  cursor: default;
`;

const LogoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 0;
  @media screen and (min-width: 768px) {
    row-gap: 6px;
  }
`;

const Seperator = styled.div`
  height: 20px;
  background-color: #8A8988;
  width: 1px;
  margin: auto 10px 10px;
  transition: all 0.2s linear;

  @media screen and (min-width: 768px) {
    height: 30px;
    margin: auto 15px 0px;
  }
  @media screen and (min-width: 1024px) {
    height: 30px;
    margin: auto 35px 0px;
  }
`;

const HeaderDescriptionCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  font-size: 12px;
  color: #000000;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
`;

interface LogoWithTextProps{
  src: any;
  headerText: string;
  onClick?: ()=>void;
  isClickable?: boolean;
  style?: object
}


const LogoWithText = ({headerText, src, onClick, isClickable = false, style}:LogoWithTextProps) =>{
  return(
    <LogoTextWrapper>
      <Text theme={themeDefault} className={HeaderDescriptionCss}>{headerText}</Text>
      <LogoImage isClickable={isClickable} style={style? style: {width:'120px'}} onClick={()=>{
        if(onClick){
          onClick();
        } 
      }} src={src} alt='bank-logo'/>
    </LogoTextWrapper>
  );
}


interface LogoComponentProps{
  width?:string;
  isClickable?:boolean;
}

const LogoComponent = ({isClickable = false} : LogoComponentProps) => {
  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);

  const goToMainWebsite = () =>{
    let avivaWebsiteUrl = get(window, 'AVIVA_VARIABLE_CONFIG.avivaWebsiteUrl');
    window.open(avivaWebsiteUrl,'_self');
  }

  if(campaignDetail?.code === CIMB_Code) {
    /*LCB1*/
    return (
      <LogoContainerWrapper>
        <LogoWithText isClickable={isClickable} headerText={'Distributed by:'} src={cimbLogo} onClick={()=>{}}></LogoWithText>
        <Seperator/>
        <LogoWithText 
          isClickable={isClickable} 
          headerText={'Underwritten by:'} 
          src={themeDefault.logoRed} 
          onClick={isClickable ? goToMainWebsite : ()=>{}} 
          style={{
            width:`${108/16}em`, 
            height:`${30/16}em`,
            display: "flex",
            position: "relative",
            right: `${5/16}em`
          }}/>
      </LogoContainerWrapper>
    )
  }
  else {
    return (
      <LogoImage width={"121px"} isClickable={isClickable} onClick={isClickable ? goToMainWebsite : ()=>{}} src={themeDefault.logoRed} alt='singlife-logo' />
    )
  }
  
}

export default LogoComponent